<template>
  <!-- 商品统计 -->
  <div class="goods_acount_box">
    <div class="goods_acount">
      <div>
        <span>商品金额共</span>
        <span>{{goodsData.receivables*1 || 0}}</span>
        <span>元</span>
        <span>
          （其中
          <span v-if="goodsData.discount<=0">订单优惠{{Math.abs(goodsData.discount*1)}}元</span>
          <span v-if="goodsData.discount>0">订单多收{{goodsData.discount*1}}元</span>）
        </span>
        <span>，{{goodsData.order_count|| 0}}单</span>
        <span>，{{goodsData.count ||0}}个商品</span>
      </div>
      <div class="time">
        <Calendar v-model="data_picker" @change="changeTime"></Calendar>
      </div>
    </div>
    <div class="list_box" v-if="list.length>0">
      <div class="list_tl">
        <span>序号</span>
        <span>商品名</span>
        <span>包装</span>
        <span>单数</span>
        <span>数量|重量</span>
        <span>均价</span>
        <span>商品金额</span>
        <span></span>
      </div>
      <div class="list_content">
        <md-scroll-view
          ref="scrollView"
          :auto-reflow="false"
          :bouncing="true"
          :scrolling-x="false"
          @end-reached="$_onEndReached"
        >
          <div
            class="list"
            v-for="(item,index) in list"
            :key="index"
            @click="goDetail(item.name,item.bale,item.goods_type,item.batch)"
          >
            <span>{{index+1}}</span>
            <span>{{item.name}}</span>
            <span>
              <span v-if="item.bale==1" style="background:#DAEFFB;color:#1D78C5">定装</span>
              <span v-if="item.bale==2" style="background:#FBEDDA;color:#BF8535">非定装</span>
              <span v-if="item.bale==3" style="background:#DAFBDB;color:#4B9C64">散装</span>
              <span v-if="item.goods_type==2"></span>
            </span>
            <span>{{item.count}}单</span>
            <span>
              <span v-if="item.goods_type==1">
                <span v-if="item.bale!=3">{{item.num*1}}{{unit_list[item.num_unit-1].name}} |</span>
                {{item.weight*1}}公斤
              </span>
              <span v-if="item.goods_type==2">
                {{item.num*1}}
                <span v-if="item.type==1">个</span>
                <span v-if="item.type==2">单</span>
              </span>
            </span>
            <span>
              <span v-if="item.goods_type==1">
                <span
                  v-if="item.bale!=3"
                >{{item.price_unit*1}}元/{{unit_list[item.num_unit-1].name}} |</span>
                {{item.price_weight*1}}元/公斤
              </span>
              <span v-if="item.goods_type==2">
                <span>
                  {{item.price_unit*1}}元
                  <span v-if="item.type==1">/个</span>
                  <span v-if="item.type==2">/单</span>
                </span>
              </span>
            </span>
            <span>{{item.goods_total_price*1}}元</span>
            <span>
              <md-icon name="arrow-right" size="sm"></md-icon>
            </span>
          </div>
          <md-scroll-view-more
            :finished-text="list.length>0?'全部已加载':'暂无数据'"
            slot="more"
            :is-finished="isFinished"
          ></md-scroll-view-more>
        </md-scroll-view>
      </div>
    </div>
    <div v-if="list.length==0" style="text-align:center;color:#999;line-height:0.8rem">暂无数据~</div>
  </div>
</template>
<script>
import { Goods_Acount_List } from "@/api/work/acount/salesAcount";
import { timestampToDate } from "@/utils/timestamp";
import Calendar from "@/components/Calendar";
export default {
  name: "creditAcount",
  components: {
    Calendar,
  },
  data() {
    return {
      unit_list: [
        { value: 1, name: "件" },
        { value: 2, name: "包" },
        { value: 3, name: "袋" },
        { value: 4, name: "盒" },
        { value: 5, name: "瓶" },
        { value: 6, name: "箱" },
        { value: 7, name: "罐" },
      ],
      goodsQuery: {
        //参数
        s: "",
        e: "",
        page: 1,
        pagesize: 55,
      },
      data_picker: [],
      isFinished: false,
      goodsData: {
        //头部总数据
        receivables: 0,
        discount: 0,
        count: 0,
        order_count: 0,
      },
      list: [],
    };
  },
  created() {
    this.getList();
  },
  mounted() {},
  methods: {
    //获取列表数据
    getList() {
      if (this.goodsQuery.page == 1) {
        this.list = [];
      }
      Goods_Acount_List(this.goodsQuery).then((res) => {
        if (res.code == 200) {
          this.goodsData.receivables = res.data.receivables;
          this.goodsData.discount = res.data.discount;
          this.goodsData.count = res.data.count;
          this.goodsData.order_count = res.data.order_count;
          this.list = this.list.concat(res.data.list);
          if (
            this.list.length == res.data.totalCount ||
            res.data.list.length == 0
          ) {
            this.isFinished = true;
          } else {
            this.isFinished = false;
            this.goodsQuery.page++;
          }
        } else {
        }
      });
    },
    //下拉刷新
    $_onEndReached() {
      if (this.isFinished) {
        return;
      }
      // async data
      this.getList();
      this.$refs.scrollView.finishLoadMore();
    },
    //选择时间
    changeTime(e) {
      if (this.data_picker) {
        this.goodsQuery.s = timestampToDate(this.data_picker[0]);
        this.goodsQuery.e = timestampToDate(this.data_picker[1]);
      } else {
        this.goodsQuery.s = "";
        this.goodsQuery.e = "";
      }
      this.goodsQuery.page = 1;
      this.list = [];
      this.getList();
    },
    //去商品统计详情
    goDetail(name, bale, goods_type,batch) {
      this.$router.push({
        path: "/data/goodsAcount/goodsAcountDetail",
        query: {
          name,
          bale,
          goods_type,
          s: this.goodsQuery.s,
          e: this.goodsQuery.e,
          batch
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
//商品统计
.goods_acount_box {
  height: 100%;
  .goods_acount {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 0.22rem;
    padding-bottom: 0.12rem;
    border-bottom: 0.01rem solid #e5e5e5;
    height: 0.6rem;
    > div:nth-of-type(1) {
      font-size: 0.22rem;
      > span:nth-of-type(1),
      > span:nth-of-type(3) {
        color: #404040;
      }
      > span:nth-of-type(2) {
        color: #31b158;
      }
      > span:nth-of-type(4) {
        color: #999999;
        font-size: 0.2rem;
      }
      > span:nth-of-type(5) {
        color: #404040;
      }
      > span:nth-of-type(6) {
        color: #404040;
      }
    }
  }
  .list_box {
    height: calc(100% - 0.6rem);
    margin: 0 0.22rem;
    .list_tl {
      height: 0.68rem;
      border-bottom: 0.01rem solid #e5e5e5;
      display: flex;
      align-items: center;
      justify-content: space-between;
      > span {
        color: #555;
        font-size: 0.22rem;
        font-weight: bold;
        text-align: center;
      }
      > span:nth-of-type(1) {
        width: 0.6rem;
        text-align: left;
      }
      > span:nth-of-type(2) {
        width: 1.4rem;
        text-align: left;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
      > span:nth-of-type(3) {
        width: 0.8rem;
      }
      > span:nth-of-type(4) {
        width: 1rem;
      }
      > span:nth-of-type(5) {
        width: 2.8rem;
      }
      > span:nth-of-type(6) {
        width: 3rem;
      }
      > span:nth-of-type(7) {
        width: 2rem;
      }
      > span:nth-of-type(8) {
        width: 0.4rem;
        text-align: right;
      }
    }
    .list_content {
      height: calc(100% - 0.68rem);
      font-size: 0.18rem;
      .list {
        height: 0.6rem;
        border-bottom: 0.01rem solid #e5e5e5;
        display: flex;
        align-items: center;
        justify-content: space-between;
        > span {
          color: #666;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          text-align: center;
        }
        > span:nth-of-type(1) {
          width: 0.6rem;
          text-align: left;
        }
        > span:nth-of-type(2) {
          width: 1.4rem;
          text-align: left;
        }
        > span:nth-of-type(3) {
          width: 0.8rem;
          text-align: center;
          display: flex;
          justify-content: center;
          > span {
            padding: 0 0.1rem;
            height: 0.24rem;
            line-height: 0.24rem;
            border-radius: 0.12rem;
            font-size: 0.18rem;
          }
        }
        > span:nth-of-type(4) {
          width: 1rem;
          text-align: center;
        }
        > span:nth-of-type(5) {
          width: 2.8rem;
          text-align: center;
        }
        > span:nth-of-type(6) {
          width: 3rem;
          text-align: center;
        }
        > span:nth-of-type(7) {
          width: 2rem;
          text-align: center;
        }
        > span:nth-of-type(8) {
          width: 0.4rem;
          text-align: right;
          font-weight: bold;
        }
      }
    }
  }
}
</style>
<style lang="less">
.time {
  .calendar_select_box {
    width: 2.6rem!important;
    border: 0.01rem solid #e5e5e5!important;
    background: #fff !important;
  }
}
</style>